import * as React from "react";
import { formatISO } from "date-fns";
import { casesActions } from "configs";
import { useCurrentCase, useDispatch, useParams } from "duck";
import { useUpdateDisclaimerMutation } from "requests";
import { FormValues } from "./types";

export const useUpdateDisclaimer = () => {
  const { id } = useParams();

  const { disclaimerId, shouldSync } = useCurrentCase(medicalCase => ({
    disclaimerId: medicalCase.data.client.disclaimer._id,
    shouldSync: medicalCase.shouldSync
  }));

  const dispatch = useDispatch();
  const [updateDisclaimer] = useUpdateDisclaimerMutation({
    ignoreResults: true
  });

  return React.useCallback(
    (values: FormValues) => {
      const variables = {
        signature: values.signature,
        createdAt: formatISO(new Date())
      };

      dispatch(
        casesActions.updateClientDisclaimer({
          _id: id,
          data: variables
        })
      );

      if (shouldSync) {
        return updateDisclaimer({
          variables: { input: { _id: disclaimerId, ...variables } }
        });
      }
    },
    [disclaimerId, updateDisclaimer, shouldSync]
  );
};
